import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { IntegracaoService } from "src/app/features/integracao/integracao.service";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { OperacaoScr } from "src/app/model/operacao-scr.model";
import { Movi, Sald } from "src/app/model/scc.model";
import { OperacaorepasseBndesService } from "../../../operacao-repasse-bndes-service";


@Component({
    selector: 'aba-amortizacao-repasse',
    templateUrl: 'aba-amortizacao-repasse.component.html',
    standalone: false
})
export class AbaAmortizacaoRepasseComponent implements OnChanges {
    @Input()
    public model:OperacaoGarantida;
    amortizacoes: Movi[];
    saldo: Sald[];

    constructor(
        private operacaoRepasseBndesService:OperacaorepasseBndesService
    ){}

    ngOnChanges(changes: SimpleChanges): void {
        this.operacaoRepasseBndesService.getAmortizacoes(this.model.id).subscribe(resp =>{
            this.amortizacoes = resp;
        });
        this.operacaoRepasseBndesService.getSaldo(this.model.id).subscribe(resp =>{
            this.saldo = resp;
        });
    }

}
